import React, { Component } from 'react';
import { deepOrange500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import RaisedButton from 'material-ui/RaisedButton';
import { historiaActions } from '../../actions/app-actions.js'
import AppStore from '../../stores/app-store.js'
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { Link } from 'react-router';
import '../../grid.css';
import './Capa.css';

const muiTheme = getMuiTheme({
	palette: {
		accent1Color: deepOrange500,
	},
});

const style = {
	margin: 12,
	float: 'right',
};

class Capa extends Component {
	constructor(props) {
		super(props);
		this.state = {
			legendas: AppStore.legendas,
		}
		this.onChangeLingua = this.onChangeLingua.bind(this);
	}
	componentWillMount() {
		AppStore.addChangeLinguaListener(this.onChangeLingua);
		historiaActions.iniciaHistoria();
	}

	componentWillUnmount() {
		AppStore.removeChangeLinguaListener(this.onChangeLingua);
	}

	onChangeLingua() {
		this.setState({
			legendas: AppStore.legendas,
		})
	}
	render() {
		return (
			<MuiThemeProvider muiTheme={muiTheme}>
				<div>
					<div className="ui-g">
						<div className="ui-g-8">
							<center><img src='./imagens/DesenhoLogo.png' alt="imagem" className="capa" /></center>
						</div>
						<div className="ui-g-4">
							<RaisedButton containerElement={<Link to="/info" />}
								linkButton={true}
								label={this.state.legendas.avancar}
								style={style}
								primary={true}
							/>
						</div>
					</div>
				</div>

			</MuiThemeProvider>
		);
	}
}

export default Capa;



// WEBPACK FOOTER //
// ./src/componentes/capa/Capa.js